<template>
  <!-- 受信（左）: アバター枠付きの行 -->
  <div v-if="isReceive" class="in-dm-chat-row">
    <div class="in-dm-chat-row__avatar">
      <InDmAvatar v-if="showAvatar" :picture-url="pictureUrl" :size="AVATAR_SIZE" />
    </div>
    <InDmMessage v-if="item.type === 'message'" :text="item.text" :side="item.side" />
    <InDmMedia v-else-if="item.type === 'media'" :url="item.url" :media-type="item.mediaType" />
    <InDmCard
      v-else-if="item.type === 'card'"
      :title="item.title"
      :subtitle="item.subtitle"
      :url="item.url"
      :media-url="item.mediaUrl"
      :card-buttons="item.cardButtons"
    />
  </div>
  <!-- 日付: 中央 -->
  <InDmDate v-else-if="item.type === 'date'" :datetime="item.datetime" />
  <!-- 送信（右）: メッセージ -->
  <InDmMessage v-else-if="item.type === 'message'" :text="item.text" :side="item.side" />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import InDmAvatar from '@/client/components/_atoms/in_dm_avatar'
import InDmDate from '@/client/components/_atoms/in_dm_date'
import InDmMessage from '@/client/components/_atoms/in_dm_message'
import InDmCard from '@/client/components/_molecules/in_dm_card'
import InDmMedia from '@/client/components/_molecules/in_dm_media'

import type { InDmChatItem } from './types'

interface Props {
  item: InDmChatItem
  showAvatar: boolean
  pictureUrl: string | null
}
const props = defineProps<Props>()

const AVATAR_SIZE = 28

const isReceive = computed(
  () =>
    (props.item.type === 'message' && props.item.side === 'left') ||
    props.item.type === 'media' ||
    props.item.type === 'card'
)
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.in-dm-chat-row {
  display: flex;
  gap: $spacing-unit;
  align-items: flex-end;
}

.in-dm-chat-row__avatar {
  flex-shrink: 0;
  width: 28px;
}
</style>
